/* ═══════════════════════════════════════════════════════════════
   Bailey & Coco — Personalised Phone Case v1
   JavaScript — Approval Flow (3-step)
   ═══════════════════════════════════════════════════════════════ */

(function() {
  'use strict';

  // ── Config ──────────────────────────────────────────────────
  var UPLOAD_ENDPOINT = 'https://bc-upload.andrewsimpson661.workers.dev/upload';

  // ── State ─────────────────────────────────────────────────
  var state = {
    photo: null,
    photoUrl: '',
    uploading: false,
    uploaded: false,
    model: '',
    name: '',
    fontStyle: 'classic',
  };

  var $ = function(sel) { return document.querySelector(sel); };
  var $$ = function(sel) { return document.querySelectorAll(sel); };
  var els = {};

  function cacheDom() {
    els.photoInput   = $('#bc-photo-input');
    els.uploadZone   = $('#bc-upload-zone');
    els.uploadDefault= $('#bc-upload-default');
    els.uploadSuccess= $('#bc-upload-success');
    els.changeBtn    = $('#bc-change-photo');
    els.deleteBtn    = $('#bc-delete-photo');
    els.photoTip     = $('#bc-photo-tip');

    els.step1        = $('#bc-step-1');
    els.step2        = $('#bc-step-2');
    els.step3        = $('#bc-step-3');
    els.step1Num     = $('#bc-step1-num');
    els.step2Num     = $('#bc-step2-num');
    els.step3Num     = $('#bc-step3-num');

    els.modelBtns    = $$('.bc-model-btn');

    els.nameInput    = $('#bc-dog-name');
    els.nameCount    = $('#bc-name-count');
    els.fontBtns     = $$('#bc-font-styles .bc-style-btn');
    els.fontPreviews = $$('.bc-style-btn__preview');

    els.addForm      = $('#bc-add-form');
    els.addBtn       = $('#bc-add-btn');
    els.ctaText      = $('#bc-cta-text');
    els.propPhoto    = $('#bc-prop-photo');
    els.propModel    = $('#bc-prop-model');
    els.propName     = $('#bc-prop-name');
    els.propStyle    = $('#bc-prop-style');

    els.stickyBtn    = $('#bc-sticky-btn');
    els.stickyText   = $('#bc-sticky-text');
    els.stickyCta    = $('#bc-sticky-cta');

    els.galleryMain  = $('#bc-gallery-main');
    els.galleryThumbs= $('#bc-gallery-thumbs');

    els.proc1        = $('#bc-proc-1');
    els.proc2        = $('#bc-proc-2');

    els.faqBtns      = $$('.bc-faq__question');
  }


  // ── Name Sanitisation ───────────────────────────────────────

  function sanitizeName(value) {
    var cleaned = value.replace(/[\u{1F600}-\u{1F64F}]/gu, '')
                       .replace(/[\u{1F300}-\u{1F5FF}]/gu, '')
                       .replace(/[\u{1F680}-\u{1F6FF}]/gu, '')
                       .replace(/[\u{1F1E0}-\u{1F1FF}]/gu, '')
                       .replace(/[\u{2600}-\u{26FF}]/gu, '')
                       .replace(/[\u{2700}-\u{27BF}]/gu, '')
                       .replace(/[\u{FE00}-\u{FE0F}]/gu, '')
                       .replace(/[\u{200D}]/gu, '')
                       .replace(/[\u{20E3}]/gu, '')
                       .replace(/[\u{E0020}-\u{E007F}]/gu, '');

    cleaned = cleaned.replace(/[^a-zA-Z0-9\s\-'&]/g, '');
    cleaned = cleaned.replace(/\s{2,}/g, ' ');
    cleaned = cleaned.trim();

    return cleaned;
  }


  // ── HEIC -> JPEG conversion (hybrid: iOS Safari native canvas, else lazy-loaded heic-to) ────

  var HEIC_TO_CDN_PRIMARY  = 'https://cdn.jsdelivr.net/npm/heic-to@1.4.2/dist/iife/heic-to.js';
  var HEIC_TO_CDN_FALLBACK = 'https://unpkg.com/heic-to@1.4.2/dist/iife/heic-to.js';

  var _heicToLoader = null;

  function loadHeicTo() {
    // heic-to IIFE exposes itself as window.HeicTo (callable function) per its src/iife.js.
    if (window.HeicTo) return Promise.resolve(window.HeicTo);
    if (_heicToLoader) return _heicToLoader;
    _heicToLoader = new Promise(function(resolve, reject) {
      var tried = 0;
      function attempt(src) {
        var s = document.createElement('script');
        s.src = src;
        s.onload = function() {
          if (window.HeicTo) { resolve(window.HeicTo); }
          else { next(); }
        };
        s.onerror = next;
        document.head.appendChild(s);
      }
      function next() {
        tried++;
        if (tried === 1) attempt(HEIC_TO_CDN_FALLBACK);
        else reject(new Error('HEIC converter unavailable'));
      }
      attempt(HEIC_TO_CDN_PRIMARY);
    });
    return _heicToLoader;
  }

  function isIOSSafari() {
    var ua = navigator.userAgent;
    var isIOS = /iP(hone|ad|od)/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var isSafari = /Safari/.test(ua) && !/(CriOS|FxiOS|EdgiOS|Chrome|Firefox|Edg)/.test(ua);
    return isIOS && isSafari;
  }

  function nativeCanvasDecode(file) {
    return new Promise(function(resolve, reject) {
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function() {
        URL.revokeObjectURL(url);
        var canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        canvas.toBlob(function(blob) {
          if (blob) resolve(blob); else reject(new Error('toBlob failed'));
        }, 'image/jpeg', 0.9);
      };
      img.onerror = function() { URL.revokeObjectURL(url); reject(new Error('Native HEIC decode failed')); };
      img.src = url;
    });
  }

  function libraryConvert(file) {
    return loadHeicTo().then(function(fn) {
      // heic-to IIFE resolves to the heicTo function itself (not an object wrapper).
      if (typeof fn !== 'function') throw new Error('HEIC converter not callable');
      return fn({ blob: file, type: 'image/jpeg', quality: 0.9 });
    });
  }

  function heicToJpeg(file) {
    var isHeic = /\.(heic|heif)$/i.test(file.name) || file.type === 'image/heic' || file.type === 'image/heif';
    if (!isHeic) return Promise.resolve(file);

    if (isIOSSafari()) {
      return nativeCanvasDecode(file).catch(function() { return libraryConvert(file); });
    }
    return libraryConvert(file);
  }


  // ── Image Compression (HEIC-aware, canvas resize before upload) ────

  function compressImage(file, maxDim, quality) {
    return heicToJpeg(file).then(function(source) {
      return new Promise(function(resolve, reject) {
        var wasConverted = source !== file;
        if (!wasConverted && source.size < 1024 * 1024) { resolve(source); return; }

        var img = new Image();
        var url = URL.createObjectURL(source);
        img.onload = function() {
          URL.revokeObjectURL(url);
          var scale = Math.min(1, maxDim / Math.max(img.width, img.height));
          var w = Math.max(1, Math.round(img.width * scale));
          var h = Math.max(1, Math.round(img.height * scale));
          var canvas = document.createElement('canvas');
          canvas.width = w;
          canvas.height = h;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, w, h);
          canvas.toBlob(function(blob) {
            var out = blob || source;
            if (out.size > 4 * 1024 * 1024) {
              reject(new Error('Photo is very large. Please try a smaller image or a screenshot.'));
              return;
            }
            resolve(out);
          }, 'image/jpeg', quality);
        };
        img.onerror = function() {
          URL.revokeObjectURL(url);
          if (source.size > 4 * 1024 * 1024) {
            reject(new Error('Photo is very large. Please try a smaller image or a screenshot.'));
          } else {
            resolve(source);
          }
        };
        img.src = url;
      });
    });
  }

  // ── Photo Upload to Server ──────────────────────────────────

  function setSlowUploadHint(show) {
    if (!els.uploadZone) return;
    var hint = els.uploadZone.querySelector('.bc-upload__slow-hint');
    if (show) {
      if (!hint) {
        hint = document.createElement('div');
        hint.className = 'bc-upload__slow-hint';
        hint.setAttribute('role', 'status');
        hint.style.cssText = 'font-size:12px;color:#666;margin-top:6px;text-align:center;';
        hint.textContent = 'Still uploading — please wait, larger photos can take up to a minute.';
        els.uploadZone.appendChild(hint);
      }
    } else if (hint) {
      hint.parentNode.removeChild(hint);
    }
  }

  function uploadPhotoToServer(file, originalName) {
    if (!UPLOAD_ENDPOINT) {
      state.uploading = false;
      state.uploaded = true;
      state.photoUrl = originalName;
      els.propPhoto.value = originalName;
      updateUI();
      return;
    }

    state.uploading = true;
    updateUI();

    var controller = new AbortController();
    var timeoutId = setTimeout(function() { controller.abort(); }, 60000);
    var slowHintId = setTimeout(function() { setSlowUploadHint(true); }, 10000);

    fetch(UPLOAD_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/octet-stream',
        'X-Filename': originalName,
      },
      body: file,
      signal: controller.signal,
    })
    .then(function(response) {
      clearTimeout(timeoutId);
      clearTimeout(slowHintId);
      setSlowUploadHint(false);
      if (!response.ok) {
        return response.json().then(function(data) {
          throw new Error((data && data.error) || 'Upload failed');
        });
      }
      return response.json();
    })
    .then(function(data) {
      if (!data || !data.filename) {
        throw new Error('Upload incomplete, please try again.');
      }
      if (data.ftp && data.ftp !== 'ok') {
        throw new Error('Upload incomplete. Please try a smaller photo.');
      }
      state.uploading = false;
      state.uploaded = true;
      state.photoUrl = data.filename;
      els.propPhoto.value = data.filename;
      updateUI();
    })
    .catch(function(err) {
      clearTimeout(timeoutId);
      clearTimeout(slowHintId);
      setSlowUploadHint(false);
      state.uploading = false;
      state.uploaded = false;
      state.photo = null;
      state.photoUrl = '';
      els.propPhoto.value = '';
      els.photoInput.value = '';
      console.error('Photo upload error:', err);
      var msg = (err && err.name === 'AbortError')
        ? 'That upload timed out. Please check your connection and try again.'
        : ((err && err.message) || 'Photo upload failed. Please try again.');
      alert(msg);
      updateUI();
    });
  }


  // ── Photo Upload ──────────────────────────────────────────

  function handlePhotoUpload(e) {
    var file = e.target.files && e.target.files[0];
    if (!file) return;

    // Validate file type
    var allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/heic', 'image/heif', 'image/webp'];
    var fileType = file.type.toLowerCase();
    var fileName = file.name.toLowerCase();
    var validType = allowedTypes.indexOf(fileType) > -1;
    var validExt = /\.(jpg|jpeg|png|heic|heif|webp)$/.test(fileName);
    if (!validType && !validExt) {
      alert('Please upload a photo of your dog. Accepted formats: JPG, PNG, HEIC or WEBP.');
      e.target.value = '';
      return;
    }

    // Validate size
    if (file.size > 10 * 1024 * 1024) {
      alert('Photo must be under 10MB. Please choose a smaller file.');
      e.target.value = '';
      return;
    }

    state.photo = file;

    // Compress (HEIC-aware) then upload. Surface any compression-time error (size guard, converter failure) to the user.
    // After HEIC conversion, compressImage always returns a JPEG blob. Rename the outgoing filename so the Worker
    // stores it with .jpg extension (matches actual content for Richie's fulfilment pipeline).
    compressImage(file, 2048, 0.82).then(function(compressed) {
      var outName = file.name;
      if (/\.(heic|heif)$/i.test(outName)) {
        outName = outName.replace(/\.(heic|heif)$/i, '.jpg');
      }
      uploadPhotoToServer(compressed, outName);
    }).catch(function(err) {
      state.uploading = false;
      state.uploaded = false;
      state.photo = null;
      state.photoUrl = '';
      if (els.propPhoto) els.propPhoto.value = '';
      if (els.photoInput) els.photoInput.value = '';
      console.error('Photo compression error:', err);
      alert((err && err.message) || 'Could not prepare this photo. Please try a different one.');
      updateUI();
    });
  }

  function deletePhoto() {
    state.photo = null;
    state.photoUrl = '';
    state.uploaded = false;
    els.propPhoto.value = '';
    els.photoInput.value = '';
    updateUI();
  }

  function triggerUpload() {
    els.photoInput.click();
  }


  // ── Model Selector ────────────────────────────────────────

  function handleModelSelect(e) {
    var btn = e.currentTarget;
    state.model = btn.dataset.model;
    els.propModel.value = state.model;

    els.modelBtns.forEach(function(b) { b.classList.remove('is-active'); });
    btn.classList.add('is-active');

    updateUI();
  }


  // ── Name & Font ───────────────────────────────────────────

  function handleNameInput(e) {
    var raw = e.target.value;
    var clean = sanitizeName(raw);

    if (clean !== raw) {
      e.target.value = clean;
    }

    state.name = clean;
    els.nameCount.textContent = state.name.length + '/21';
    els.propName.value = state.name;

    var displayName = state.name || 'Name';
    els.fontPreviews.forEach(function(preview) {
      preview.textContent = displayName;
    });

    updateUI();
  }

  function handleFontSelect(e) {
    var btn = e.currentTarget;
    state.fontStyle = btn.dataset.style;
    els.propStyle.value = state.fontStyle;
    els.fontBtns.forEach(function(b) { b.classList.remove('is-active'); });
    btn.classList.add('is-active');
  }


  // ── Gallery ───────────────────────────────────────────────

  function initGallery() {
    if (!els.galleryThumbs) return;
    els.galleryThumbs.addEventListener('click', function(e) {
      var thumb = e.target.closest('.bc-gallery__thumb');
      if (!thumb) return;
      var index = thumb.dataset.index;
      $$('.bc-gallery__thumb').forEach(function(t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      $$('.bc-gallery__image').forEach(function(el) {
        el.classList.remove('is-active');
        var v = el.tagName === 'VIDEO' ? el : el.querySelector('video');
        if (v) v.pause();
      });
      var target = els.galleryMain.querySelector('[data-index="' + index + '"]');
      if (target) {
        target.classList.add('is-active');
        var vid = target.querySelector('video');
        if (vid) {
          vid.play().catch(function() {});
        }
      }
    });
  }


  // ── FAQ ────────────────────────────────────────────────────

  function initFAQ() {
    els.faqBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var answer = btn.nextElementSibling;
        els.faqBtns.forEach(function(b) {
          b.setAttribute('aria-expanded', 'false');
          b.nextElementSibling.classList.remove('is-open');
          b.nextElementSibling.setAttribute('aria-hidden', 'true');
        });
        if (!expanded) {
          btn.setAttribute('aria-expanded', 'true');
          answer.classList.add('is-open');
          answer.setAttribute('aria-hidden', 'false');
        }
      });
    });
  }


  // ── Check SVG helpers ──────────────────────────────────────

  var checkSvg = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
  var checkSvgGreen = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4A7C59" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
  var cameraSvg = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#D4849A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"/><circle cx="12" cy="13" r="4"/></svg>';


  // ── UI Update ─────────────────────────────────────────────

  function updateUI() {
    var hasPhoto = !!state.photo;
    var hasModel = !!state.model;
    var hasName  = state.name.trim().length > 0;
    var ready    = hasPhoto && state.uploaded && hasModel && hasName && !state.uploading;

    // Upload zone states
    els.uploadDefault.style.display = hasPhoto ? 'none' : '';
    els.uploadSuccess.style.display = hasPhoto ? '' : 'none';
    els.photoTip.style.display = hasPhoto ? 'none' : '';

    // ── Step 1 number ──
    if (hasPhoto) {
      els.step1Num.classList.remove('is-active');
      els.step1Num.classList.add('is-done');
      els.step1Num.innerHTML = checkSvg;
    } else {
      els.step1Num.classList.add('is-active');
      els.step1Num.classList.remove('is-done');
      els.step1Num.textContent = '1';
    }

    // ── Step 2 (Model) enable/disable ──
    if (hasPhoto) {
      els.step2.classList.remove('bc-step--disabled');
      els.step2.classList.add('bc-step--enabled');
      if (hasModel) {
        els.step2Num.classList.remove('is-active');
        els.step2Num.classList.add('is-done');
        els.step2Num.innerHTML = checkSvg;
      } else {
        els.step2Num.classList.add('is-active');
        els.step2Num.classList.remove('is-done');
        els.step2Num.textContent = '2';
      }
    } else {
      els.step2.classList.add('bc-step--disabled');
      els.step2.classList.remove('bc-step--enabled');
      els.step2Num.classList.remove('is-active');
      els.step2Num.classList.remove('is-done');
      els.step2Num.textContent = '2';
    }

    // ── Step 3 (Name/Font) enable/disable ──
    if (hasPhoto && hasModel) {
      els.step3.classList.remove('bc-step--disabled');
      els.step3.classList.add('bc-step--enabled');
      if (hasName) {
        els.step3Num.classList.remove('is-active');
        els.step3Num.classList.add('is-done');
        els.step3Num.innerHTML = checkSvg;
      } else {
        els.step3Num.classList.add('is-active');
        els.step3Num.classList.remove('is-done');
        els.step3Num.textContent = '3';
      }
    } else {
      els.step3.classList.add('bc-step--disabled');
      els.step3.classList.remove('bc-step--enabled');
      els.step3Num.classList.remove('is-active');
      els.step3Num.classList.remove('is-done');
      els.step3Num.textContent = '3';
    }

    // ── Process steps ──
    if (hasPhoto) {
      els.proc1.classList.remove('is-active');
      els.proc1.classList.add('is-done');
      els.proc1.querySelector('.bc-proc-step__icon').innerHTML = checkSvgGreen;
      els.proc2.classList.add('is-active');
    } else {
      els.proc1.classList.add('is-active');
      els.proc1.classList.remove('is-done');
      els.proc1.querySelector('.bc-proc-step__icon').innerHTML = cameraSvg;
      els.proc2.classList.remove('is-active');
    }

    // ── CTA button ──
    var priceText = document.querySelector('.bc-price') ? document.querySelector('.bc-price').textContent : '\u00a325.00';
    var ctaCopy;

    if (state.uploading) {
      ctaCopy = 'Uploading photo\u2026';
    } else if (ready) {
      ctaCopy = 'Add to Basket - ' + priceText;
    } else if (!hasPhoto) {
      ctaCopy = 'Upload a photo to get started';
    } else if (!hasModel) {
      ctaCopy = 'Choose your iPhone model';
    } else {
      ctaCopy = "Enter your dog\u2019s name to continue";
    }

    els.ctaText.textContent = ctaCopy;
    els.addBtn.disabled = !ready;

    if (ready) {
      els.addBtn.classList.add('is-ready');
    } else {
      els.addBtn.classList.remove('is-ready');
    }

    // Mobile sticky CTA sync
    if (els.stickyBtn) {
      els.stickyText.textContent = ctaCopy;
      els.stickyBtn.disabled = !ready;
      if (ready) {
        els.stickyBtn.classList.add('is-ready');
      } else {
        els.stickyBtn.classList.remove('is-ready');
      }
    }
  }


  // ── Form Submit ───────────────────────────────────────────

  // Build the line-item properties payload from state. Mirrors the keys
  // declared as hidden inputs in personalised-case.liquid so the canonical
  // /cart/add.js POST carries exactly the data the form would have submitted.

  /* BC_FONT_LABEL - put the real typeface name on the order so production never
     has to translate a slug. Keep this map in step with the @font-face in the
     section and with the font installed in Photoshop. */
  var BC_FONT_LABELS = {
    classic:  'Classic (Georgia)',
    elegant:  'Elegant (Yellowtail)',
    modern:   'Modern (Helvetica Neue / Arial)',
    playful:  'Playful (Comic Sans MS)'
  };
  function bcFontLabel(slug){
    return BC_FONT_LABELS[slug] || slug || '';
  }

  function buildProperties() {
    return {
      'Image_1':      state.photoUrl || '',
      'iPhone Model': state.model || '',
      'Name_1':       sanitizeName(state.name).trim(),
      'Font':         bcFontLabel(state.fontStyle || 'classic'),
      '_Font code':   state.fontStyle || 'classic'
    };
  }

  // Submit via fetch to /cart/add.js so properties are carried in the JSON
  // body. This bypasses any global form-submit interception (e.g. Smart Cart)
  // that was stripping properties[*] hidden inputs and landing orders with
  // zero personalisation data.
  function submitToCart(variantId, properties) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, properties: properties })
    }).then(function(resp) {
      if (!resp.ok) {
        return resp.text().then(function(txt) {
          var msg = 'Add to cart failed (' + resp.status + ')';
          try { var j = JSON.parse(txt); if (j.description) msg = j.description; } catch(_) {}
          throw new Error(msg);
        });
      }
      return resp.json();
    }).then(function(item) {
      var drawerHandled = false;
      if (window.CartDrawer && typeof window.CartDrawer.refresh === 'function') {
        try { window.CartDrawer.refresh(); } catch(_) {}
        if (typeof window.CartDrawer.open === 'function') {
          try { window.CartDrawer.open(true); drawerHandled = true; } catch(_) {}
        }
      }
      try { document.dispatchEvent(new CustomEvent('cart:refresh',  { bubbles: true })); } catch(_) {}
      try { document.dispatchEvent(new CustomEvent('cart:updated',  { bubbles: true, detail: { item: item } })); } catch(_) {}
      if (!drawerHandled) {
        setTimeout(function() { window.location.href = '/cart'; }, 400);
      }
      return item;
    });
  }

  function getVariantId() {
    var input = els.addForm && els.addForm.querySelector('input[name="id"]');
    return input ? input.value : null;
  }

  var isSubmitting = false;
  function handleSubmit(e) {
    e.preventDefault();
    if (isSubmitting) return false;
    if (!state.photo || !state.uploaded || !state.model || !state.name.trim() || state.uploading) {
      return false;
    }
    isSubmitting = true;
    els.propName.value = sanitizeName(state.name); // keep DOM in sync for analytics
    submitToCart(getVariantId(), buildProperties()).catch(function(err) {
      console.error('Cart add failed:', err);
      alert(err.message || 'Unable to add to cart. Please try again.');
      isSubmitting = false;
    });
  }

  function handleStickyClick() {
    if (state.photo && state.uploaded && state.model && state.name.trim() && !state.uploading) {
      if (isSubmitting) return;
      isSubmitting = true;
      els.propName.value = sanitizeName(state.name);
      submitToCart(getVariantId(), buildProperties()).catch(function(err) {
        console.error('Cart add failed:', err);
        alert(err.message || 'Unable to add to cart. Please try again.');
        isSubmitting = false;
      });
    } else {
      var target = !state.photo ? els.step1 : !state.model ? els.step2 : els.step3;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }


  // ── Upload zone interactions ──────────────────────────────

  function initUploadZone() {
    els.uploadDefault.addEventListener('click', triggerUpload);

    els.uploadZone.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (!state.photo) triggerUpload();
      }
    });

    els.photoInput.addEventListener('change', handlePhotoUpload);
    els.changeBtn.addEventListener('click', function(e) { e.stopPropagation(); triggerUpload(); });
    els.deleteBtn.addEventListener('click', function(e) { e.stopPropagation(); deletePhoto(); });

    // Drag & drop
    els.uploadZone.addEventListener('dragover', function(e) {
      e.preventDefault();
      if (!state.photo) {
        els.uploadDefault.style.borderColor = '#D4849A';
        els.uploadDefault.style.background = 'rgba(245,230,235,0.6)';
      }
    });
    els.uploadZone.addEventListener('dragleave', function(e) {
      e.preventDefault();
      if (!state.photo) {
        els.uploadDefault.style.borderColor = '';
        els.uploadDefault.style.background = '';
      }
    });
    els.uploadZone.addEventListener('drop', function(e) {
      e.preventDefault();
      els.uploadDefault.style.borderColor = '';
      els.uploadDefault.style.background = '';
      var files = e.dataTransfer.files;
      if (files && files.length > 0) {
        var dt = new DataTransfer();
        dt.items.add(files[0]);
        els.photoInput.files = dt.files;
        handlePhotoUpload({ target: { files: [files[0]] } });
      }
    });
  }


  // ── Init ──────────────────────────────────────────────────

  function init() {
    cacheDom();
    if (!els.uploadZone) return;

    initUploadZone();
    initGallery();
    initFAQ();

    // Model buttons
    els.modelBtns.forEach(function(btn) {
      btn.addEventListener('click', handleModelSelect);
    });

    // Name input
    els.nameInput.addEventListener('input', handleNameInput);

    // Sanitise on paste
    els.nameInput.addEventListener('paste', function(e) {
      setTimeout(function() {
        var clean = sanitizeName(els.nameInput.value);
        els.nameInput.value = clean;
        state.name = clean;
        els.nameCount.textContent = clean.length + '/21';
        els.propName.value = clean;
        var displayName = clean || 'Name';
        els.fontPreviews.forEach(function(preview) {
          preview.textContent = displayName;
        });
        updateUI();
      }, 0);
    });

    // Font style buttons
    els.fontBtns.forEach(function(btn) {
      btn.addEventListener('click', handleFontSelect);
    });

    // Form submit
    els.addForm.addEventListener('submit', handleSubmit);

    // Sticky CTA
    if (els.stickyBtn) {
      els.stickyBtn.addEventListener('click', handleStickyClick);
    }

    updateUI();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
